const CANCEL_REASON_MAX_LENGTH = 900;

const generateCancelReasonHelperText = (value: string): string =>
    `${value ? value.length : 0} / ${CANCEL_REASON_MAX_LENGTH} characters used`;

export { CANCEL_REASON_MAX_LENGTH, generateCancelReasonHelperText };
